import React from 'react';

import SignIn from '../../components/Auth/SignIn';

const Login = () => (
  <SignIn />
);

export default Login;